import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TrackClick } from 'pages/certificates/tracking'

export const TrailerComingSoonPauseScreen = ({
  onClickBack,
}: {
  onClickBack: () => void
}) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <div
      className='position-absolute d-flex flex-column justify-content-center align-items-center c-text-color--light'
      style={{ inset: 0, background: 'rgba(var(--c-beige-1400-rgb), 0.9)' }}
    >
      <h2 className='c-d-1 c-text-ivar-display-condensed c-mb-6'>
        {t('marketingPages.comingSoonTrailer.title')}
      </h2>
      <p className='c-mb-6'>{t('marketingPages.comingSoonTrailer.body')}</p>
      <TrackClick event='certificateLandingClick'>
        <Button
          kind='tertiary'
          className='c-text-color--light'
          onClick={onClickBack}
        >
          {t('marketingPages.comingSoonTrailer.back')}
        </Button>
      </TrackClick>
    </div>
  )
}
